import { render, staticRenderFns } from "./PageConnectWearablesSkeleton.vue?vue&type=template&id=ffef8778&scoped=true"
import script from "./PageConnectWearablesSkeleton.vue?vue&type=script&lang=js"
export * from "./PageConnectWearablesSkeleton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffef8778",
  null
  
)

export default component.exports